import { DisplayDataItem, FormattedDateTime, Row } from '@elotech/components';

import { AuditInfo } from '../../type';

export const DisplayAuditDataItem = ({ audit }: { audit?: AuditInfo }) => {
  if (!audit) return null;

  return (
    <>
      <Row>
        <DisplayDataItem title="Usuário criação" md={3} sm={3}>
          {audit?.usuarioCriacao}
        </DisplayDataItem>
        <DisplayDataItem title="Data criação" md={3} sm={3}>
          <FormattedDateTime value={audit?.dataCriacao} />
        </DisplayDataItem>
      </Row>
      <Row>
        <DisplayDataItem title="Última edição" md={3} sm={3}>
          {audit?.usuarioAlteracao}
        </DisplayDataItem>
        <DisplayDataItem title="Data última edição" md={3} sm={3}>
          <FormattedDateTime value={audit?.dataAlteracao} />
        </DisplayDataItem>
      </Row>
    </>
  );
};
